import React from 'react';
import BasicSearch from './TableSearch/BasicSearch';
import AdvancedSearch from './TableSearch/AdvancedSearch';
import { TableSearchProps } from './TableSearch/types';

const TableSearch: React.FC<TableSearchProps> = ({
  mode,
  onModeChange,
  basicSearchTerm,
  onBasicSearchChange,
  onBasicSearchClear,
  basicPlaceholder,
  advancedFieldConfigs,
  advancedQuery,
  onAdvancedSearch,
  onAdvancedClear,
}) => {
  return (
    <div style={styles.containerStyle}>
      {/* Search Mode Toggle - Inline with search */}
      <div style={styles.headerRowStyle}>
        {mode === 'basic' || mode === 'basicOnly' ? (
          <div style={styles.basicSearchContainerStyle}>
            <BasicSearch
              searchTerm={basicSearchTerm}
              placeholder={basicPlaceholder}
              onSearchTermChange={onBasicSearchChange}
              onClearSearch={onBasicSearchClear}
            />
          </div>
        ) : (
          <div style={styles.advancedSearchContainerStyle}>
            <AdvancedSearch
              fieldConfigs={advancedFieldConfigs}
              query={advancedQuery}
              onSearch={onAdvancedSearch}
              onClear={onAdvancedClear}
            />
          </div>
        )}

        {/* Segmented Control Toggle */}
        {(mode === 'basic' || mode === 'advanced') && (
          <div style={styles.toggleContainerStyle}>
            <button
              onClick={() => onModeChange('basic')}
              style={{
                ...styles.toggleButtonStyle,
                ...(mode === 'basic' ? styles.toggleButtonActiveStyle : {}),
              }}>
              Basic
            </button>
            <button
              onClick={() => onModeChange('advanced')}
              style={{
                ...styles.toggleButtonStyle,
                ...(mode === 'advanced' ? styles.toggleButtonActiveStyle : {}),
              }}>
              Advanced
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
  } as React.CSSProperties,
  headerRowStyle: {
    display: 'flex',
    gap: '1rem',
    alignItems: 'flex-start',
  } as React.CSSProperties,
  basicSearchContainerStyle: {
    flex: 1,
  } as React.CSSProperties,
  advancedSearchContainerStyle: {
    flex: 1,
  } as React.CSSProperties,
  toggleContainerStyle: {
    display: 'flex',
    borderRadius: '0.375rem',
    border: '1px solid #d1d5db',
    overflow: 'hidden',
    backgroundColor: '#f9fafb',
    alignSelf: 'flex-start',
  } as React.CSSProperties,
  toggleButtonStyle: {
    padding: '0.5rem 1rem',
    backgroundColor: 'transparent',
    border: 'none',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'transparent',
    cursor: 'pointer',
    fontSize: '0.8125rem',
    fontWeight: '500',
    color: '#6b7280',
    transition: 'all 0.2s',
    whiteSpace: 'nowrap',
  } as React.CSSProperties,
  toggleButtonActiveStyle: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
  } as React.CSSProperties,
};

export default TableSearch;
